import { createTheme } from "@mui/material/styles";
declare module "@mui/material/styles" {
  interface Palette {
    accent: { main: string };
    white: { main: string };
  }
  interface PaletteOptions {
    accent?: { main: string };
    white?: { main: string };
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#89C6CE",
    },
    accent: { main: "#569FA7" },

    secondary: {
      main: "#F5A623",
    },
    background: {
      default: "#0B0B0B",
      paper: "#fff",
    },
    text: {
      primary: "#082A2E",
      secondary: "#9E9E9E",
    },
    action: {
      disabled: "#666666",
      disabledBackground: "#2a2a2a",
    },
    ...{
      white: {
        main: "#121212",
      },
    },
  },
  typography: {
    fontFamily: "vaziriFont",
    h1: { fontSize: "2.5rem", fontWeight: 700, color: "#082A2E" },
    h2: { fontSize: "2rem", fontWeight: 600, color: "#082A2E" },
    h6: {
      fontSize: "18px",
      fontWeight: 600,
      color: "#082A2E",
    },
    body1: { fontSize: "1rem", color: "#082A2E" },
    button: { textTransform: "none", fontWeight: 500, color: "#082A2E" },
    subtitle1: { fontSize: "32px", color: "#082A2E", fontWeight: "Bold" },
  },

  shape: {
    borderRadius: 12,
  },
  components: {
    MuiRadio: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: "#569FA7",
          },
          "& .MuiSvgIcon-root": {
            fontSize: 18,
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiStack: {
      styleOverrides: {
        root: {
          "& > :not(style) ~ :not(style)": {
            marginLeft: "0 !important",
            marginTop: "0 !important",
          },
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: "#CFCFCF !important",
        },

        input: {
          color: "#121212",
          "&::placeholder": {
            textAlign: "center",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#CFCFCF",
        },
        input: {
          padding:'10px !important',
          color: "#121212",
          backgroundColor: "#CFCFCF",
          borderRadius: "8px",
        },
      },
    },
    // MuiSelect: {
    //   styleOverrides: {
    //     select: {
    //       backgroundColor: "#89C6CE !important",
    //     },
    //   },
    // },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          right: "16px",
          left: "auto",
          transformOrigin: "top right",
          textAlign: "right",
          direction: "rtl",
          border: "8px !important",
          backgroundColor: "#CFCFCF !important",
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        input: {
          textAlign: "right",
        },
      },
    },
  },
});

export default theme;
